export default __webpack_public_path__ + "static/alibabacloud-office-95d31a6c7525c5fd80d837a2f2af5e27.jpg";